import { render, staticRenderFns } from "./BureauFormModal.vue?vue&type=template&id=66ef6dda&scoped=true"
import script from "./BureauFormModal.vue?vue&type=script&lang=js"
export * from "./BureauFormModal.vue?vue&type=script&lang=js"
import style0 from "./BureauFormModal.vue?vue&type=style&index=0&id=66ef6dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef6dda",
  null
  
)

export default component.exports